<div *ngIf="!items || items.length == 0">
	<h3>No Products</h3>
	<p>We couldn't find any products that match your query</p>
</div>
<div *ngIf="orderable && items && items.length > 0" class="row gx-1" cdkDropListGroup>
	<div
		cdkDropList
		class="col-6 col-md-3"
		(cdkDropListEntered)="onDropListEntered($event)"
		(cdkDropListDropped)="onDropListDropped()"
		*ngFor="let item of items"
	>
		<app-collection-item cdkDrag class="" [layout]="type" [editable]="false" [product]="item"></app-collection-item>
	</div>
</div>
<div *ngIf="!orderable && items && items.length > 0" class="row gx-1">
	<div class="col-6 col-md-3 mb-1" *ngFor="let item of items">
		<app-collection-item class="" [layout]="type" [editable]="false" [product]="item"></app-collection-item>
	</div>
</div>
